export default __webpack_public_path__ + "static/media/use2.586fed3c.png";